import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { toastr } from 'react-redux-toastr';
import CreateScreensaverComponent from './component';

class CreateScreensaverContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      imagePath: '',
      imageDescription: '',
      imageType: '',
      VmTypeId: '',
      VmTypeOption: [],
      ScreensaverUrl: '',
      imageLoaded: false,
    };
  }
  componentDidMount() {
    this.setState(prev => ({
      loading: true
    }));
    
    this.props.getDataFromAPI(
      `/vendingmachines/vmtypes`,
      'GET',
      undefined,
      response => {
        const VmTypeOption = response.list.map(vmType=>({
          value: vmType.id,
          text: vmType.type
        }))
        this.setState(prev =>({
         VmTypeOption ,
         loading : false
        }));
      },
      err => {
        toastr.error('ERROR', 'Unable to fetch VM types');
        console.log(err);
        this.setState(prev =>({
          loading: false
        }))
      }
    );
    
  }

  onChangeOnImagePath = (e,data)=>{
    this.setState(prev => ({
      imagePath: data.value,
      ScreensaverUrl: `${prev.imageType}/${data.value}`,
      imageLoaded: false
    }))
  }

  

  onChangeOnImageDescription = (e,data)=>{
    this.setState(prev => ({
      imageDescription: data.value
    }))
  }

  onChangeOnVmTypeId = (e,data)=>{    
    this.setState(prev =>({
      VmTypeId: data.value
    }));
  }

  onChangeOnImageType = (e,data)=>{
    
    this.setState(prev =>({
      imageType: data.value,
      ScreensaverUrl: `${data.value}/${prev.imagePath}`,
      imageLoaded: false

    }));
  }
  
  onClickOnSave = () => {
    const {imageDescription,VmTypeId,imageType,imagePath,imageLoaded}= this.state;
    if(!imageDescription || !VmTypeId || !imageType || !imagePath){
      toastr.error('ERROR', 'Form Fields Are Empty');
      return;
    }
    if(!imageLoaded){
      toastr.error('ERROR', 'Image Not Found');
      return;
    }
    this.props.getDataFromAPI(
      `/screensaver/new`,
      'POST',
      {
        imageDescription,
        imagePath,
        imageType,
        VmTypeId: parseInt(VmTypeId,10)
      },
      response => {        
        toastr.success('Successful', 'Added New Image');
        this.props.history.replace(`/vendingmachines/rc/screensaver/update/${response.image_id}`);
      },
      err => {
        toastr.error('ERROR', err.message);
        console.log(err);
      }
    );
  }
  onImageLoad = () => {
    this.setState(prev => ({
      imageLoaded: true
    }));
  }

  render() {
    
    return (
      <CreateScreensaverComponent 
      imagePath={this.state.imagePath}
      imageDescription={this.state.imageDescription}
      imageType={this.state.imageType}
      VmTypeId={this.state.VmTypeId}
      ScreensaverUrl={this.state.ScreensaverUrl}
      imageLoaded={this.state.imageLoaded}
      VmTypeOption={this.state.VmTypeOption}
      onChangeOnImagePath={this.onChangeOnImagePath}
      onChangeOnImageId={this.onChangeOnImageId}
      onChangeOnImageDescription={this.onChangeOnImageDescription}
      onChangeOnImageType={this.onChangeOnImageType}
      onChangeOnVmTypeId={this.onChangeOnVmTypeId}
      onClickOnSave={this.onClickOnSave}
      onClickOnDelete={this.onClickOnDelete}
      onImageLoad={this.onImageLoad}
      />
    );
  }
}
export default connect(
  null,
  { getDataFromAPI }
)(CreateScreensaverContainer);



// WEBPACK FOOTER //
// ./src/Modules/CreateImage/container.jsx